<!--
 * @Author: 
 * @Date: 2020-04-13 17:44:36
 * @LastEditors: teng
 * @LastEditTime: 2021-02-08 15:49:21
 * @Description: file content
 -->
<template>
  <div class="index">
    <div class="index-bg">
      <div class="logo">
        <img
          :src="imgHost + 'logo.png'"
        />
      </div>
      <div class="slogan">
        <img
          :src="imgHost + 'slogan.png?v=1'"
        />
      </div>
      <div class="index-main">
        <template v-if="voiceInfo">
          <div class="item">
            <img class="headImg" :src="voiceInfo.headImg" alt />
            <div class="voice-box" @click="playAudio">
              <img
                :src="imgHost + 'voice.png'"
              />
              <div :class="flag == true ? 'unread' : ''"></div>
            </div>
          </div>
          <!-- <div class="bottom">
          <img :src="imgHost + 'index_bg_bottom.png'" />
          </div>-->
          <div class="text">直接点击收听好友语音</div>
        </template>
        <div
          class="goMain"
          @click="goMain"
        >
          读语音拿金喜
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator, MessageBox } from "mint-ui";
import Vue from "vue/dist/vue.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      voiceInfo: {},
      assistantFareStatus: "", //是否领取过话费  1：已经领取 0：未领取
      flag: true,
      fromOpenName: "",
      isReceivedTelFare: true,
      user: {},
      playVoice: true
    };
  },

  filters: {},
  watch: {},
  computed: {},
  methods: {
    goMain() {
      this.$goPage("index?status=1");
    },
    // 播放语音
    playAudio() {
      if (!this.playVoice) {
        return
      }
      this.playVoice = false
      let that = this;
      this.$audio.bg.pause();
      this.flag = false;
      window.ConfigAudio = new Audio();
      console.log(window.ConfigAudio);
      window.ConfigAudio.src = that.voiceInfo.voiceUrl;
      window.ConfigAudio.play(
        { loop: false, src: that.voiceInfo.voiceUrl },
        () => {}
      );
      window.ConfigAudio.addEventListener("ended", function () {
        that.$audio.bg.play();
        that.playVoice = true;
        if (!window.bgAudioIsManualClose) {
          that.$audio.bg.play();
        }
      });
    },
    //ip定位
    async getLocationByIp() {
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      let that = this;
      const data = await this.$httpdf.get(this.apiHost + 'user/getLocationByIp')
      Indicator.close();
      if (data.code == 0) {
        if (!data.data.curLocation) {
          //本地测试用====================================>>>>>
          // that.localCity = that.$root.curLocation.location;
          // that.isLocation = true;  //默认在区域内
          //<<<<<=============================================

          //如果没有curLocation，说明ip定位失败，调取gps定位
          await that.getLocationByGps();
        } else {
          Vue.prototype.$infoId = data.data.curLocation.infoId;
          await this.getParticipate()
        }
      } else {
        MessageBox.alert(data.msg)
      }
    },
    //gps定位
    async getLocationByGps() {
      //  let res = { latitude: 30.585323333740234, longitude: 114.36740112304688 };
      let that = this;
      that.$wx.ready(() => {
        that.$wx.getLocation().then((res) => {
          Indicator.open({
            text: "加载中...",
            spinnerType: "fading-circle",
          });
          console.log("$wx.getLocation", res);
          // let url = `${that.$apidf.xc_voice_purchase.getLocationByGps}?latitude=${res.latitude}&longitude=${res.longitude}&fromOpenId=${that.$fopenid}&openId=${that.$openid}`;
          that.$httpdf
            .get(
              this.apiHost + 'user/getLocationByGps',
              {
                fromOpenId: this.$fopenid, //有就传，用于保存浏览记录
                openId: this.$openid,
                latitude: res.latitude,
                longitude: res.longitude,
              }
            )
            .then( async (data) => {
              Indicator.close();
              console.log("getLocationByGps---", data);
              if (data.code === 0) {
                if (!data.data.curLocation) {
                  return;
                }
                Vue.prototype.$infoId = data.data.curLocation.infoId;
                await this.getParticipate()
              }
            });
        });
      });
    },
    // 参与游戏
    async getParticipate () {
      this.$util.cookie.set("infoId", this.$infoId, {
        expires: 60,
      });
      const data = await this.$httpdf.post(this.apiHost + 'user/participate')
      if (data.code == 0) {
        Vue.prototype.$key = data.data.nonceStr
        this.$util.cookie.set("key", this.$key, {
          expires: 60,
        });
        if (data.data.mobile) {
          Vue.prototype.$mobile = data.data.mobile
          this.$util.cookie.set("mobile", this.$mobile, {
            expires: 60,
          });
        }
      }else{
        if(this.timeStatus === 1){
          MessageBox.alert("活动未开始！");
        } else if (this.timeStatus === 3){
          MessageBox.alert("活动已结束！");
        } else {
          MessageBox.alert(data.msg);
        }
      }
    },
  },
  async created() { 
    await this.getLocationByIp(); //首先ip定位
    const data2 = await this.$httpdf.get(this.apiHost + 'lucky/prize/getTelFarePrizeId')
    const data = await this.$httpdf.get(this.apiHost + 'assistance/isPopUpPrize', { prizeId: data2.data })
    if (data.code === 0) {
      this.user = data.data
      this.$modal.drawForm.alert({ prizeId: data2.data, user: this.user })
    }
    const data1 = await this.$httpdf.post(this.apiHost + `voice/selectVoiceInfo?openId=${this.$fopenid}`)
    if (data1.code === 0) {
      this.voiceInfo = data1.data.voiceInfo
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.index {
  background: url($imgHost + 'bg.jpg') center 0 / 100% no-repeat;
  overflow-x: hidden;
}

.index-bg {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  position: relative;
  align-items: center;
  .logo {
    padding-top: 22px;
    width: $logoWidth;
  }
  
  .slogan {
    width: $sloganWidth;
    position: relative;
    z-index: 2;
    margin-top: 74px;
  }
  
  .browseCount {
    position: relative;
    width: 345px;
    display: flex;
    margin-top: 6px;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .browseCount-info {
      width: 110px;
      height: 18px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 9px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 18px;
      text-align: center;
    }
  }



  .index-main {
    position: relative;
    // bottom: 34px;
    width: 375px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    .item {
      height: 44px;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .headImg {
      width: 48px;
      height: 48px;
      border: 2px solid #7DDCFC;
      border-radius: 50%;
      display: block;
    }

    .voice-box {
      width: 170px;
      margin-left: 16px;
      position: relative;
    }

    .voice-box img {
      width: 100%;
    }

    .unread {
      position: absolute;
      right: 4px;
      bottom: 2px;
      width: 5px;
      height: 5px;
      background: #F941DD;
      border-radius: 50%;
    }

    .text {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #fff;
      text-align: center;
      margin-top: 12px;
      z-index: 1;
    }

    .goMain {
      width: 280px;
      height: 44px;
      background: linear-gradient(180deg, #7CDCFC 0%, #E889FD 100%);
      border-radius: 22px;
      font-size: 22px;
      font-family: Adobe Heiti Std;
      font-weight: bold;
      color: #fff;
      text-align: center;
      letter-spacing: 4px;
      margin-top: 26px;
      @extend .flex-center-center;
    }
  }
  
  .index-btm {
    width: 100%;
    min-height: 411px;
    background: url($imgHost + 'bg4.png') center bottom / 100% no-repeat
  }
}
.index-txt {
  margin-top: 10px;
  text-align: center;
  p {
    display: inline-block;
    background: #267C55;
    border-radius: 2px;
    font-size: 14px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FFFFFF;
    padding: 5px;
    margin-bottom: 10px;
  }
}
</style>
